import styled from 'styled-components';
import Row from './Row';
import Cell from './Cell';

export default styled.tbody`
  ${Row} {
    &:last-child {
      ${Cell} {
        &:first-child {
          border-bottom-left-radius: 4px;
        }

        &:last-child {
          border-bottom-right-radius: 4px;
        }
      }
    }
  }
`;
